export default class PortfoliosIndex {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');

    // Reload with attrs
    let reloadWithSelectedParams = function() {
      let url = '/' + accountUrl + '/portfolios';
      let params = {};
      let status = $('#portfolios_table').attr('data-filters-status');
      let clientId = $('#portfolios_table').attr('data-filters-client-id');
      let ownerId = $('#portfolios_table').attr('data-filters-owner-id');
      if (typeof ownerId !== 'undefined') {params['owner_id'] = ownerId}
      if (typeof status !== 'undefined') {params['status'] = status.toLowerCase()}
      if (typeof clientId !== 'undefined') {params['client_id'] = clientId}
      Turbo.visit(url + '?' + $.param(params));
    }

    // On filter select
    $('#search_portfolio_statuses').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
      ev.preventDefault();
      $('.tooltip').tooltip('hide');
      $('#portfolios_table').attr('data-filters-status', suggestion);
      reloadWithSelectedParams();
      $(this).blur();
    });

    // On selecting a client
    $('#clients_search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      $('#portfolios_table').attr('data-filters-client-id', suggestion.record_id);
      reloadWithSelectedParams();
    })

    // On selecting an owner
    $('#search_portfolios_by_owner').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      $('#portfolios_table').attr('data-filters-owner-id', suggestion.record_id);
      reloadWithSelectedParams();
    })

  }


}